import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=43013508&scoped=true&"
import script from "./parent.vue?vue&type=script&lang=js&"
export * from "./parent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43013508",
  null
  
)

export default component.exports